// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.speccard {\r\n    padding-left: 80px !important;\n}\n.filter-msg {\r\n    padding-top: 30px;\r\n    text-align: left;\r\n    font-style: italic;\r\n    color: grey;\n}\n.no-specs {\r\n    font-size: large;\r\n    padding: 100px;\r\n    padding-right: 180px;\r\n    color: grey;\r\n    font-style: italic;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
